module.exports = __webpack_public_path__ + "58a2c501a20c10805882249395e86c66.jpg";